import { ApiCore } from '@/services/api/utils/core.js'

const url = 'my-pitstops'
const plural = 'pitstops'
const single = 'pitstop'

const api = new ApiCore({
	index: true,
	url: url,
	plural: plural,
	single: single
})

export default api
